export function trapFocus(container: HTMLElement | null): () => void {
	if (!container) return () => {};

	const focusableElements = container.querySelectorAll<HTMLElement>(
		'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
	);

	if (focusableElements.length === 0) return () => {};

	const firstElement = focusableElements[0];
	const lastElement = focusableElements[focusableElements.length - 1];

	function handleTabKey(e: KeyboardEvent) {
		if (e.key !== 'Tab') return;

		if (e.shiftKey) {
			if (document.activeElement === firstElement) {
				e.preventDefault();
				lastElement?.focus();
			}
		} else if (document.activeElement === lastElement) {
			e.preventDefault();
			firstElement?.focus();
		}
	}

	container.addEventListener('keydown', handleTabKey);

	return () => {
		container.removeEventListener('keydown', handleTabKey);
	};
}
